'use strict';

var configure = require('./lib/configure');

module.exports = configure(function (api) {
  return function () {
    var url = new URL(api.opts.base || '');
    return {
      host: url.hostname,
      port: url.port,
      protocol: url.protocol,
      pathname: url.pathname,
      'api-path': url.pathname
    };
  };
});